export default __webpack_public_path__ + "static/even-right-deco-369ea7f956e87ff0954bfed69f35274b.png";